<template lang="pug">
    div
        div( v-if="uploadsLoading") 
            fan-loader(
                :loading="uploadsLoading"
            )
                div(slot="loadingMsg" 
                    class="full-width text-xs-center headline my-2") Uploading your image...
            
        v-card-text(v-if="!uploadsLoading")
            .display-1 Upload an Image
            .caption.my-3 {{ helperText }}

            div( :class="hasImage ? null : 'main'" )
                ImageUploader(
                    :preview="true"
                    :capture="false"
                    :autoRotate="true"
                    accept="image/*"
                    outputFormat="verbose"
                    @input="setImage"
                )
    
                p.font-weight-thin.mt-2 Supports: JPEG, PNG

            SaveButton(
                :isEnabled="hasImage"
                :onSave="saveImage"
            )
            
</template>

<script>
import ImageUploader from 'vue-image-upload-resize'
import SaveButton from '@/components/SaveButton.vue'
import FanLoader from 'Components/FanLoader.vue'
import { mapActions } from 'vuex'

export default {
    components: {
        ImageUploader,
        FanLoader,
        SaveButton
    }, 
    data: () => ({ 
        hasImage: false,
        content: null,
        type: null,
        encoding: null,
        uploadsLoading: false
    }), 
    props: {
        applicationId: String,
        lender: String,
        helperText: String
    },
    methods: {
        ...mapActions([
            'saveImageUploads'
        ]),
        setImage(file) {
            this.hasImage = true
            this.image = file.dataUrl
        },
       async saveImage() {
           this.uploadsLoading = true
            const type = this.image.slice(5, this.image.indexOf(';'))
            const encoding = this.image.slice(this.image.indexOf(';') + 1, this.image.indexOf(','))
            const content = this.image.slice(this.image.indexOf(',') + 1, this.image.length -1)
            const image = {
                contentType: type,
                contentEncoding: encoding,
                content
            }
            try {
                await this.saveImageUploads({
                    lenderName: this.lender, 
                    applicationId: this.applicationId, 
                    image
                })
                this.uploadsLoading = false    
                this.$emit('finishedSaving')  
            } catch (error) {
                this.$emit('registerError', error.message)
                this.uploadsLoading = false
            }
          
          
        }
    },
    beforeDestroy(){
        this.$emit('turnUploadingOff')
    }
}
</script>

<style lang="scss" scoped>

    .main {
        margin: 25%;
    }

    span:hover{
        color: blue
    }

</style>